import type { KeyboardEvent, MouseEvent } from "react";
import { type ContextMenuItem, type ContextMenuState, useContextMenu } from "../ContextMenu/ContextMenu";
import { isAppleUserAgent, type ShellMenuActions, searchHint, shellMenuItems } from "./shellMenu";

const SHELL_TARGET = "page";

export interface ShellContextMenu {
  /** Spread on the shell's root element. */
  areaProps: {
    onContextMenu: (e: MouseEvent<HTMLElement>) => void;
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => void;
  };
  menuProps: {
    state: ContextMenuState<typeof SHELL_TARGET> | null;
    items: ContextMenuItem[];
    onClose: () => void;
  };
}

/**
 * The suite's general right-click menu, wherever a screen has no menu of its own (a screen's menu
 * marks the event as handled first, so this one steps aside).
 */
export function useShellContextMenu(actions: Omit<ShellMenuActions, "searchHint">): ShellContextMenu {
  const shellMenu = useContextMenu<typeof SHELL_TARGET>({ resolve: () => SHELL_TARGET });
  return {
    areaProps: {
      onContextMenu: (e) => {
        if (!e.defaultPrevented) shellMenu.triggerProps.onContextMenu(e);
      },
      onKeyDown: (e) => {
        if (!e.defaultPrevented) shellMenu.triggerProps.onKeyDown(e);
      },
    },
    menuProps: {
      state: shellMenu.state,
      items: shellMenuItems({ ...actions, searchHint: searchHint(isAppleUserAgent()) }),
      onClose: shellMenu.close,
    },
  };
}
